/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A free ${i?.label} typing test. Type the text below for ${i?.label} and see your words-per-minute and accuracy when the time is up.`)
};

const es_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un test de mecanografía gratis de ${i?.label}. Escribe el texto de abajo durante ${i?.label} y consulta tus palabras por minuto y precisión cuando se acabe el tiempo.`)
};

const de_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein kostenloser ${i?.label} Tipptest. Tippe den Text unten ${i?.label} lang und sieh deine Wörter pro Minute und Genauigkeit, sobald die Zeit abgelaufen ist.`)
};

const nl_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Een gratis typetest van ${i?.label}. Typ de tekst hieronder gedurende ${i?.label} en bekijk je woorden per minuut en nauwkeurigheid zodra de tijd om is.`)
};

const fr_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un test de frappe gratuit de ${i?.label}. Tapez le texte ci-dessous pendant ${i?.label} et découvrez vos mots par minute et votre précision une fois le temps écoulé.`)
};

const it_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un test di digitazione gratuito da ${i?.label}. Digita il testo qui sotto per ${i?.label} e scopri le tue parole al minuto e la precisione allo scadere del tempo.`)
};

const pt_br2_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um teste de digitação de ${i?.label} grátis. Digite o texto abaixo durante ${i?.label} e veja suas palavras por minuto e precisão quando o tempo acabar.`)
};

const pt_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um teste de escrita gratuito de ${i?.label}. Escreva o texto abaixo durante ${i?.label} e veja as suas palavras por minuto e precisão quando o tempo terminar.`)
};

const ja_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料の${i?.label}タイピングテストです。${i?.label}の間、下のテキストを入力し続け、時間終了時にWPMと正確率を確認しましょう。`)
};

const zh_typing_variant_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费${i?.label}打字测试。输入下方文本，持续${i?.label}，时间到后查看您的每分钟字数和准确率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_intro = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_intro", locale)
	if (locale === "en") return en_typing_variant_intro(inputs)
	if (locale === "es") return es_typing_variant_intro(inputs)
	if (locale === "de") return de_typing_variant_intro(inputs)
	if (locale === "nl") return nl_typing_variant_intro(inputs)
	if (locale === "fr") return fr_typing_variant_intro(inputs)
	if (locale === "it") return it_typing_variant_intro(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_intro(inputs)
	if (locale === "pt") return pt_typing_variant_intro(inputs)
	if (locale === "ja") return ja_typing_variant_intro(inputs)
	return zh_typing_variant_intro(inputs)
};